//var $ = require('../modules/jquery');
var _throttle = require('lodash/throttle');

(function($) {
  // Functions
  // ---------------------------------------------------------------------------
  function toggleCollapseButton(e) {
    var button = $(e.target);
    var titles = button
      .parent()
      .find('.panel__heading [data-toggle="collapse"]');
    var panels = button.parent().find('.panel__content');
    var toggle_status = button.attr('aria-expanded');

    // toggle the status of the title
    if (toggle_status === 'true') {
      button.attr('aria-expanded', 'false').text('Open all');
      titles.attr('aria-expanded', 'false');
      panels.attr('aria-hidden', 'true');
    } else {
      button.attr('aria-expanded', 'true').text('Close all');
      titles.attr('aria-expanded', 'true');
      panels.attr('aria-hidden', 'false');
    }
  }

  function toggleCollapsePanel(e) {
    // toggle the status of the title
    var title = $(e.target);
    var title_status = title.attr('aria-expanded');
    var panel = title.parents('.panel__heading');

    if (title_status === 'true') {
      title.attr('aria-expanded', 'false');
    } else {
      title.attr('aria-expanded', 'true');
    }

    // toggle the display of the panel
    var title_control = title.attr('aria-controls');
    var collapse_panel = $('#' + title_control);
    var panel_status = collapse_panel.attr('aria-hidden');

    if (panel_status === 'true') {
      collapse_panel.attr('aria-hidden', 'false');
    } else {
      collapse_panel.attr('aria-hidden', 'true');
      // If panel is pinned, unpin it and scroll back to correct position
      if (panel.hasClass('heading--pinned')) {
        panel.removeClass('heading--pinned');
        $('html, body').animate(
          {
            scrollTop: $(panel).offset().top - 150
          },
          300
        );
      }
    }

    // change toggle button text if all opened/closed
    var collapse_toggle = $('.panel-group--accordion .panel-group__toggle');
    var opened_count = title
      .closest('.panel-group--accordion')
      .find('[data-toggle="collapse"][aria-expanded="true"]').length;
    var items_count = title
      .closest('.panel-group--accordion')
      .find('.panel').length;

    if (opened_count === items_count) {
      collapse_toggle.attr('aria-expanded', 'true').text('Close all');
    }
  }

  function initClosingTitles() {
    // Get height of header for offset calculations
    var offset = $('#header-container').outerHeight();

    // Track scroll position
    var scroll_position = $(window).scrollTop() + offset;

    // Get all panels that are visible
    var panels = $(
      '.panel-group--accordion .panel__content[aria-hidden="false"]'
    );

    // Loop through each visible title
    panels.each(function () {
      var width_active;

      // setup triggers for top/bottom positions for title
      var title = $(this)
        .parent()
        .find('.panel__heading');
      var title_height = title.outerHeight();
      var title_top = title.offset().top;

      // // get properties of group container
      // var group_width = $(this).width();
      // var group_height = $(this).outerHeight();
      // var group_top = $(this).offset().top;
      // var group_bottom = group_top + group_height - title_height;

      var panel = $(this);
      var panel_width = panel.width();
      var panel_height = panel.outerHeight();
      var panel_top = panel.offset().top;
      var panel_bottom = panel_top + panel_height;

      // setup positions for locked titles
      // var pinned_max = group_height - title_height - 32;

      // Apply bottom padding to group for anchoring title
      // -------------------------------------------------
      //$(this).css('padding-bottom', title_height + 32);

      // If position is after panel (panel visible above)
      // ------------------------------------------------
      if (scroll_position > panel_bottom) {
        panel.css('padding-top', '');
        title.removeClass('heading--pinned');
      }

      // If position is inside panel (panel top above window)
      // ----------------------------------------------------
      if (scroll_position >= panel_top && scroll_position <= panel_bottom) {
        panel.css('padding-top', title_height);
        title.addClass('heading--pinned');
        title.removeAttr('style');
        title.css('width', panel_width);
      }

      // If position is before panel (panel visible below)
      // -------------------------------------------------
      if (scroll_position < panel_top) {
        $(this).css({
          'padding-top': ''
          //'padding-bottom': title_height + 32
        });
        title.removeClass('heading--pinned');
        title.removeAttr('style');
      }
    });
  }

  var scrollPositionCheck = _throttle(function () {
    initClosingTitles();
  }, 10);

  // Initializations
  // ---------------------------------------------------------------------------
  $(document).ready(function() {
    var collapse_toggle = $('.panel-group--accordion .panel-group__toggle');
    var collapse_title = $('.panel-group--accordion [data-toggle="collapse"]');
    collapse_toggle.on('click', function(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      toggleCollapseButton(e);
    });
    collapse_title.on('click', function(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      toggleCollapsePanel(e);
    });
  });

  var scrollPositionCheck = _throttle(function() {
    initClosingTitles();
  }, 10);

  $(window).on('scroll', scrollPositionCheck);
})(window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/collapse.js
// module id = 14
// module chunks = 18